import React from 'react';
import Label from "../../UI/Label";
import { arrowWidth, trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track11ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track11ARed" transform="translate(2117.616760, 440.003971)" className="track">
		<g stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeWidth={tracksWidth}>
			<path
				d="M56.5732162,7.81274049 L56.0244263,37.1900671 M55.7848999,50.0121798 L54.0970595,140.364122"
				strokeLinecap="round"
				transform="translate(55.447940, 74.088431) rotate(55.000000) translate(-55.447940, -74.088431) "/>

			<TrackArrow
				transform="translate(87.747086, 52.192180) rotate(-32.000000) translate(-87.747086, -52.192180) "
				points="91.7470864 60.1921802 83.7470864 52.1921802 91.7470864 44.1921802"/>

			<line
				x1="134.223301" y1="4.10453298" x2="127.505468" y2="49.4063792" id="Path-"
				strokeLinecap="round"
				transform="translate(130.864385, 26.755456) rotate(55.000000) translate(-130.864385, -26.755456) "/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track11ARed')}
			coords="35.000000, 56.996029"
			text="11A"
			textCoordsX="8.26318359"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track11ARed.propTypes = trackPropTypes;

export default Track11ARed;

